import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-file-input', {
    display: 'flex',
    marginBottom: '12px',
});

cssRule('.tb-file-input input[type="file"]', {
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\'',
    filter: 'alpha(opacity=0)',
    opacity: 0,
    position: 'absolute',
    left: 0,
    top: 0,
    height: 0,
    width: 0,
});

cssRule('.tb-file-input .tb-filename-label', {
    verticalAlign: 'top',
    paddingTop: '5px',
    paddingRight: '18px',
});

cssRule('.tb-file-input .tb-filename-display', {
    width: '200px',
    height: '19px',
    marginLeft: '6px',
    marginRight: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    fontSize: '11px',
    fontFamily: 'inherit',
    flex: 1,
    '-webkit-flex': 1,
});

